import { Component } from "react";

// Import SVG from 'react-svg';

export class GlyphLoading extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <span className="glyph glyph-loading">
        <svg viewBox="0 0 100 100">
          <rect className="bk" fill="none" height="100" width="100" y="0" x="0"/>
          <rect transform="rotate(0 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(30 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.08333333333333333s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(60 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.16666666666666666s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(90 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.25s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(120 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.3333333333333333s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(150 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.4166666666666667s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(180 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.5s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(210 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.5833333333333334s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(240 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.6666666666666666s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(270 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.75s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(300 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.8333333333333334s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
          <rect transform="rotate(330 50 50) translate(0 -30)" fill="#00b2ff" ry="5" rx="5" height="20" width="7" y="40" x="46.5">
            <animate repeatCount="indefinite" begin="0.9166666666666666s" dur="1s" to="0" from="1" attributeName="opacity"/>
          </rect>
        </svg>
      </span>
    );
  }
}
